import { render, staticRenderFns } from "./navbar1.vue?vue&type=template&id=58356052&scoped=true"
import script from "./navbar1.vue?vue&type=script&lang=js"
export * from "./navbar1.vue?vue&type=script&lang=js"
import style0 from "./navbar1.vue?vue&type=style&index=0&id=58356052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58356052",
  null
  
)

export default component.exports